import React from "react";

// Corps d'un événement standard du parcours : description, commentaire
// (HTML fourni par l'API) et listes de données.
const TimelineEventBody = ({ event }) => {
  const dataLists = event.dataList || [];
  if (!event.description && !event.comment && dataLists.length === 0) return null;

  return (
    <div className="tl__body">
      {event.description ? <p>{event.description}</p> : null}
      {event.comment ? (
        <p>
          <i className="fa fa-comment mr-2" aria-hidden="true" />
          <span dangerouslySetInnerHTML={{ __html: event.comment }} />
        </p>
      ) : null}
      {dataLists.map((list, lk) => (
        <div key={`evdatalist${event.id}${lk}`}>
          <div>
            <strong>{list.title}</strong>
          </div>
          <ul>
            {list.list.map((item, itk) => (
              <li key={`evdatalistitem${event.id}${item}${itk}`}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default TimelineEventBody;
